import React from 'react';
import { Link } from 'react-router-dom';
import PanchTatvaButton from './PanchTatvaButton';
import { useStrings } from '../i18n';

export default function PanchTatvaCard({ image, name, nameKey, description, descriptionKey, price, onAddToCart, link, objectFit = 'contain' }) {
  const strings = useStrings();
  const resolvedName = name || (nameKey && strings.products && strings.products[nameKey] && strings.products[nameKey].name) || '';
  const resolvedDescription = description || (descriptionKey && strings.products && strings.products[descriptionKey] && strings.products[descriptionKey].description) || '';
  const cardContent = (
    <>
      {/* {image && <img src={image} alt={name} className="h-64 w-full object-cover rounded-xl mb-4" />} */}

      {image && (
        <div className={`rounded-xl mb-3 md:mb-4 overflow-hidden flex items-center justify-center bg-cardBg h-40 md:h-64${objectFit === 'cover' ? '' : ' p-3'}`}>
          <img
            src={image}
            alt={resolvedName}
            className={`w-full h-full ${objectFit === 'cover' ? 'object-cover' : 'object-contain'}`}
            loading="lazy"
            decoding="async"
          />
        </div>
      )}
      <h3 className="text-lg md:text-2xl font-heading mb-2 text-primary">{resolvedName}</h3>
      {resolvedDescription && <p className="text-xs md:text-sm text-textSecondary mb-3 md:mb-4 line-clamp-2">{resolvedDescription}</p>}
      {/* {price && <p className="text-base md:text-xl font-semibold text-secondary mb-3 md:mb-4">₹{price}</p>} */}
      {onAddToCart && <PanchTatvaButton onClick={(e) => { e.preventDefault(); onAddToCart(); }}>{strings.card.addToCart}</PanchTatvaButton>}
      {link && <span className="block mt-3 md:mt-4 text-sm md:text-base text-accent hover:underline transition">{strings.card.viewDetails}</span>}
    </>
  );

  return link ? (
    <Link
      to={link}
      className="block bg-surface rounded-2xl shadow-card p-4 md:p-6 text-center transition-transform transform hover:-translate-y-2 hover:scale-105 hover:shadow-xl relative overflow-hidden shimmer-hover"
    >
      {cardContent}
    </Link>
  ) : (
    <div className="bg-surface rounded-2xl shadow-card p-4 md:p-6 text-center transition-transform transform hover:-translate-y-2 hover:scale-105 hover:shadow-xl relative overflow-hidden shimmer-hover">
      {cardContent}
    </div>
  );
}
